// F2 v2 «Emerald» — UI-звуки: гранулированный шелест листвы.
// Вместо одного шумового «пшш» (звучит как помехи) — рой из десятков
// микро-шорохов 6-20мс со случайной высотой/временем/панорамой.
// Именно нерегулярность даёт ощущение настоящих листьев.
let ctx = null;
let noiseBuf = null;
let lastHover = 0;

const ensureCtx = () => {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
        const len = Math.floor(ctx.sampleRate * 1.2);
        noiseBuf = ctx.createBuffer(1, len, ctx.sampleRate);
        const d = noiseBuf.getChannelData(0);
        let last = 0;
        for (let i = 0; i < len; i++) {
            const w = Math.random() * 2 - 1;
            last = (last + 0.045 * w) / 1.045; // сглаженный (коричневатый) шум
            d[i] = last * 3.8;
        }
    }
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
};

// одна «гранула» — микро-шорох одного листика
const grain = (at, vol, freq, len, pan) => {
    const c = ctx;
    const src = c.createBufferSource();
    src.buffer = noiseBuf;
    src.playbackRate.value = 0.6 + Math.random() * 0.5;

    const bp = c.createBiquadFilter();
    bp.type = 'bandpass';
    bp.frequency.value = freq;
    bp.Q.value = 1.6 + Math.random(); // узкая полоса = «сухой» тихий щелчок листа

    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, at);
    g.gain.linearRampToValueAtTime(vol, at + len * 0.35);
    g.gain.linearRampToValueAtTime(0.0001, at + len);

    let node = g;
    if (c.createStereoPanner) {
        const p = c.createStereoPanner();
        p.pan.value = pan;
        g.connect(p);
        node = p;
    }
    src.connect(bp).connect(g);
    node.connect(c.destination);
    src.start(at, Math.random() * 0.7, len + 0.02);
    src.stop(at + len + 0.03);
};

// рой гранул: count листиков за время spread
const rustle = (count, spread, baseVol) => {
    const c = ensureCtx();
    if (!c) return;
    const t0 = c.currentTime + 0.01;
    for (let i = 0; i < count; i++) {
        // плотность к началу выше, к концу реже (затухающий шорох)
        const pos = Math.pow(Math.random(), 0.6) * spread;
        // огибающая роя: тише к концу
        const env = 1 - (pos / spread) * 0.7;
        grain(
            t0 + pos,
            baseVol * env * (0.5 + Math.random() * 0.5),
            900 + Math.random() * 2300,   // полоса живых листьев ~0.9-3.2кГц
            0.012 + Math.random() * 0.022, // гранулы 12-34мс
            (Math.random() * 2 - 1) * 0.6
        );
    }
};

// hover — пара листиков шевельнулась
export const sfxHover = () => {
    const now = performance.now();
    if (now - lastHover < 110) return;
    lastHover = now;
    rustle(7, 0.09, 0.05);
};

// click — ветка качнулась, листья отозвались
export const sfxClick = () => {
    rustle(16, 0.16, 0.075);
};

// открытие меню — волна по кроне
export const sfxOpen = () => {
    rustle(30, 0.45, 0.06);
};
